export default "__VITE_ASSET__CAfaqUtk__"